import {HostApplicationStoreType} from 'hostApplicationStoreType';

/**
 * OneTrust groups
 * @param {HostApplicationStoreType} store - Host Application state
 * @returns {Array<string>} String with a list of active OneTrust groups from host application
 */
export const getCookieGroups = (store: HostApplicationStoreType): string[] => store.oneTrustGroups;
